import TableFiltersContextProvider from "@/common/contexts/Table.context";
import { guardCheck } from "@/common/utils";
import { Loader } from "@/components";
import { lazy, Suspense } from "react";
import { redirect } from "react-router";

const BuildingsMePage = lazy(
  () => import("@/pages/VendorsPages/BuildingsMe.page")
);
const Buildings = lazy(() => import("@/pages/AIRXPages/Buildings.page"));

const buildingsRoute = [
  {
    path: "buildings/me",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "buildings/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <TableFiltersContextProvider>
        <Suspense fallback={<Loader />}>
          <BuildingsMePage />
        </Suspense>
      </TableFiltersContextProvider>
    ),
  },
  {
    path: "buildings-list",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "buildings");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <TableFiltersContextProvider>
        <Suspense fallback={<Loader />}>
          <Buildings />
        </Suspense>
      </TableFiltersContextProvider>
    ),
  },
];

export default buildingsRoute;
